export default __webpack_public_path__ + "static/media/amx.1a8107c3.png";